import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import apifunctions from '../../api/functions';
import api from '../../api/api';
import moment from 'moment';

const VisibilizarProdModal = ({onSubmit, id, row}) => {
    const [show, setShow] = useState(false);
    const [productividad, setProductividad] = useState(false);
    const [error, setError] = useState(null);
    
    const productividad_id = id && id()
  
    useEffect(() => {
      if (productividad_id && show) {
        const getAndProcess = (reintento = 0) => {
          const failureCallback = () => {
  
          }
          const successCallback = (data) => {
            if(data.success){
              setProductividad({
                ...data.productividad,
              })
            }else{
              setError(data.error);
            }
          }
          apifunctions.get(api.proyectos.cargadatos.productividad.gestionListVisibilizar, productividad_id, null, null, successCallback, failureCallback, failureCallback);
        }
        getAndProcess();
      }
    }, [show]);
  
    const toggle = () => setShow(!show);
  
    const enviar = () => {
    const callback = () => {
      setProductividad(false);
      if (onSubmit) onSubmit();
    };
      apifunctions.post(api.proyectos.cargadatos.productividad.gestionListVisibilizar, productividad_id, null, callback, callback, callback);
      setShow(false);
    }
  
    const permisos = (localStorage.permisos.includes('administrador'));
    const visible = productividad && moment(productividad.fecha_visualizacion_productividad).isBefore(moment());
    return (
      
      <React.Fragment>
         {permisos &&
          <React.Fragment>
        <Button
          id="btn-visibilizar-prod"
          color={"primary"}
          className="btn-sm h-100 rounded"
          onClick={() => setShow(true)}
        ><i className="fa fa-eye fa-lg"></i></Button>
        <UncontrolledTooltip target="btn-visibilizar-prod">
          Visibilizar
        </UncontrolledTooltip>
        <Modal className="ui-modal-dialog ui-modal-md modal-primary" toggle={toggle} isOpen={show}>
          <ModalHeader toggle={toggle}>
            Visibilizar productividad
          </ModalHeader>
          <ModalBody>
            <div className="ui-form">
              {error && <div className="ui-alert ui-alert-danger">{error}</div>}
              <section className="ui-section-block">
                <h5 className="ui-section-label">Datos de la productividad</h5>
                {
                  productividad && productividad_id ? (
                    <div className="ui-detail-list">
                      <div>
                        <span>Presupuesto</span>
                        <strong>{productividad.nroProyecto}</strong>
                      </div>
                      <div>
                        <span>Empresa</span>
                        <strong>{productividad.empresa_nombre}</strong>
                      </div>
                      <div>
                        <span>Personal</span>
                        <strong>{productividad.personal_nombre}</strong>
                      </div>
                    </div>
                  ) : (
                    <div className="ui-alert ui-alert-warning mb-0">
                      No hay una productividad seleccionada.
                    </div>
                  )
                }
              </section>
              <section className="ui-section-block mt-3">
                <h5 className="ui-section-label">Estado</h5>
                {
                  productividad_id && !visible ? (
                    <div className="ui-alert ui-alert-info mb-0">
                      La productividad será visible para sus ejecutores.
                    </div>
                  ) : (
                    <div className="ui-alert ui-alert-danger mb-0">
                      {
                        productividad_id
                          ? "Esta productividad ya se encuentra visible."
                          : "No hay una productividad seleccionada."
                      }
                    </div>
                  )
                }
              </section>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              disabled={!productividad_id || visible}
              onClick={enviar}
            >Confirmar</Button>
            {' '}
            <Button
              onClick={() => setShow(false)}
              color="secondary"
              >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal> 
        </React.Fragment>
        }
      </React.Fragment>
      )
  }
  
export default VisibilizarProdModal



// WEBPACK FOOTER //
// ./src/views/Imputaciones/VisibilizarProdModal.js